import { VStack, Box, Col, Row } from "@reverb-ui/react";
import { IconVariationEnum } from "data/constants/constants";
import { panelsInfo } from "helper/panelsHelper";
import { ListCardSkeleton } from "presentation/components/Skeleton/CardSkeleton";
import { SortedTableSkeleton } from "presentation/components/Skeleton/SortedTableSkeleton";
import { SortedTable } from "presentation/components/SortedTable";
import { useContext } from "react";
import { MetricCard } from "../../components/MetricCard";
import { CreativeSummaryContext } from "../context-api/CreativeSummaryProvider";
import PanelContainer from "presentation/components/PanelContainer";

const creativeSummaryInfo = panelsInfo.creativeSummary;

export const CreativeSummaryReports = () => {
  const {
    requestParamsIndex,
    creativeSummaryData,
    downloadCreativeSummaryReport,
    downloadingReports,
    isLoading,
  } = useContext(CreativeSummaryContext);

  return (
    <PanelContainer
      panelId={creativeSummaryInfo.htmlId}
      panelName={creativeSummaryInfo.description}
      rangeName={creativeSummaryData?.range}
      isLoading={isLoading}
      downloadOptions={{
        onClickGenerateCSV: downloadCreativeSummaryReport,
        downloadingReports: downloadingReports,
        panelInfo: creativeSummaryInfo,
        filterStateIndex: requestParamsIndex,
      }}
    >
      <Row>
        <Col
          col={!isLoading && creativeSummaryData?.cards.length === 0 ? 0 : 3}
        >
          {isLoading ? (
            <ListCardSkeleton
              numberOfCards={2}
              spacingBetween={5}
              hasSubText={true}
              hasVariationPeriod={true}
            />
          ) : (
            <VStack w="full" spacing={5}>
              {creativeSummaryData?.cards.map((item, index) => (
                <MetricCard
                  key={index}
                  order={item.order}
                  iconName={item.iconTitle}
                  title={item.title}
                  description={item.text}
                  variation={item.percentageVariation}
                  variationPeriod={item.previousRange}
                  variationType={item.iconVariation as IconVariationEnum}
                  subDescription={item.subText}
                />
              ))}
            </VStack>
          )}
        </Col>
        <Col
          col={!isLoading && creativeSummaryData?.cards.length === 0 ? 12 : 9}
        >
          <Box
            bg="white"
            w="full"
            p={6}
            height={400}
            overflow="auto"
            className="sortedTable"
          >
            {isLoading ? (
              <SortedTableSkeleton numberOfColumns={6} />
            ) : (
              <SortedTable
                dataColumns={creativeSummaryData?.summary.dataColumns || []}
                dataRows={creativeSummaryData?.summary.dataRows || []}
              />
            )}
          </Box>
        </Col>
      </Row>
    </PanelContainer>
  );
};
